var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 26,
    viewBox: "0 0 114 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.4729 19.7672L62.0415 6.26068H65.7762L70.3449 19.7672H67.281L66.3745 17.0115H61.4251L60.5187 19.7672H57.4729ZM62.2047 14.564H65.5949L63.5282 8.18241H64.2896L62.2047 14.564Z",
    fill: "url(#paint0_linear_947_33)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.7993 19.7672V8.70817H48.3728V6.26068H57.9815V8.70817H54.6094V19.7672H51.7993Z",
    fill: "url(#paint1_linear_947_33)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6316 19.7672V6.26068H42.7985C43.7292 6.26068 44.551 6.42385 45.2641 6.75018C45.9893 7.07651 46.5574 7.55997 46.9683 8.20054C47.3792 8.84112 47.5847 9.63278 47.5847 10.5755C47.5847 11.4941 47.3732 12.2797 46.9502 12.9324C46.5272 13.5729 45.9591 14.0564 45.246 14.3827L48.328 19.7672H45.1735L41.8376 13.8026L43.6506 14.8722H40.4417V19.7672H37.6316ZM40.4417 12.4247H42.8166C43.2155 12.4247 43.56 12.3462 43.85 12.189C44.1401 12.0319 44.3637 11.8144 44.5208 11.5364C44.69 11.2584 44.7746 10.9381 44.7746 10.5755C44.7746 10.2008 44.69 9.87451 44.5208 9.59652C44.3637 9.31853 44.1401 9.10098 43.85 8.94386C43.56 8.78673 43.2155 8.70817 42.8166 8.70817H40.4417V12.4247Z",
    fill: "url(#paint2_linear_947_33)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9556 19.7672V6.26068H36.0385V8.70817H29.7656V11.7721H35.6759V14.2196H29.7656V17.3197H36.0385V19.7672H26.9556Z",
    fill: "url(#paint3_linear_947_33)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3149 19.7672V6.26068H25.561V8.70817H19.125V12.1347H24.6545V14.5821H19.125V19.7672H16.3149Z",
    fill: "url(#paint4_linear_947_33)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16117 19.9848C6.14592 19.9848 5.20318 19.8095 4.33296 19.459C3.46274 19.1085 2.7013 18.619 2.04864 17.9905C1.40806 17.3499 0.906477 16.6066 0.543886 15.7606C0.181295 14.9145 0 13.996 0 13.0049C0 12.0138 0.175252 11.0953 0.525757 10.2492C0.888348 9.40316 1.38993 8.66589 2.03051 8.0374C2.68317 7.40891 3.44461 6.91941 4.31483 6.56891C5.18505 6.2184 6.13383 6.04315 7.16117 6.04315C8.18851 6.04315 9.13729 6.2184 10.0075 6.56891C10.8777 6.91941 11.6331 7.40891 12.2737 8.0374C12.9264 8.66589 13.428 9.40316 13.7785 10.2492C14.1411 11.0953 14.3223 12.0138 14.3223 13.0049C14.3223 13.996 14.1411 14.9145 13.7785 15.7606C13.4159 16.6066 12.9082 17.3499 12.2556 17.9905C11.615 18.619 10.8596 19.1085 9.98938 19.459C9.11916 19.8095 8.17643 19.9848 7.16117 19.9848ZM7.16117 17.4466C7.77758 17.4466 8.34564 17.3379 8.86535 17.1203C9.39715 16.9028 9.86248 16.6006 10.2613 16.2138C10.6602 15.815 10.9684 15.3436 11.1859 14.7997C11.4035 14.2558 11.5123 13.6576 11.5123 13.0049C11.5123 12.3522 11.4035 11.76 11.1859 11.2282C10.9684 10.6843 10.6602 10.2129 10.2613 9.8141C9.86248 9.41525 9.39715 9.11309 8.86535 8.90762C8.34564 8.69007 7.77758 8.58129 7.16117 8.58129C6.54477 8.58129 5.97067 8.69007 5.43887 8.90762C4.91915 9.11309 4.45987 9.41525 4.06102 9.8141C3.66217 10.2129 3.35397 10.6843 3.13641 11.2282C2.91886 11.76 2.81008 12.3522 2.81008 13.0049C2.81008 13.6576 2.91886 14.2558 3.13641 14.7997C3.35397 15.3436 3.66217 15.815 4.06102 16.2138C4.45987 16.6006 4.91915 16.9028 5.43887 17.1203C5.97067 17.3379 6.54477 17.4466 7.16117 17.4466Z",
    fill: "url(#paint5_linear_947_33)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0562 0H99.7843V0.0280323L82.6705 21.2766C84.801 20.7533 87.5435 20.4916 90.898 20.4916H92.9304C95.9579 20.4916 99.9712 20.7766 104.97 21.3466C105.223 21.3934 105.807 21.4307 106.722 21.4588C110.039 21.4588 112.151 21.0616 113.058 20.2674C113.058 21.3139 112.693 22.4025 111.964 23.5332C111.432 24.3461 110.493 24.9955 109.147 25.4814C108.259 25.715 107.129 25.8318 105.755 25.8318C104.765 25.8318 102.204 25.673 98.0743 25.3553C97.0184 25.3085 95.7149 25.2852 94.1638 25.2852H93.2387C89.6506 25.2852 82.0678 25.5235 70.4905 26L89.3562 4.8496H73.0562C73.0188 4.8496 73.0001 4.82624 73.0001 4.77952V0.0700809C73.0001 0.0233603 73.0188 0 73.0562 0Z",
    fill: "url(#paint6_linear_947_33)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_947_33",
    x1: 57.4729,
    y1: 13.0139,
    x2: 70.3449,
    y2: 13.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_947_33",
    x1: 48.3728,
    y1: 13.0139,
    x2: 57.9815,
    y2: 13.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_947_33",
    x1: 37.6316,
    y1: 13.0139,
    x2: 48.328,
    y2: 13.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_947_33",
    x1: 26.9556,
    y1: 13.0139,
    x2: 36.0385,
    y2: 13.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_947_33",
    x1: 16.3149,
    y1: 13.0139,
    x2: 25.561,
    y2: 13.0139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_947_33",
    x1: 0,
    y1: 13.014,
    x2: 14.3223,
    y2: 13.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E95E40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_947_33",
    x1: 70.6645,
    y1: 13.5972,
    x2: 115.233,
    y2: 13.5972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97340"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E94059"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.05cab693c88289489d3c2f1934f82e6f.svg";
export { ForwardRef as ReactComponent };